"use client";
// @ts-strict-ignore

import BannerNashvillePromo from "components/common/bannerNashvillePromo";
import dynamic from "next/dynamic";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";

const Card = dynamic(() => import("components/common/card"));
const Banner = dynamic(() => import("components/common/banner"));
const BadgesUk = dynamic(() => import("components/common/badgesUk"));
const CardHorizontal = dynamic(
  () => import("components/common/cardHorizontal")
);
const CardHorizontalInfo = dynamic(
  () => import("components/common/cardHorizontalInfo")
);
const CardFlipSlider = dynamic(
  () => import("components/common/cardFlipSlider")
);
const FiveCardFlipGrid = dynamic(
  () => import("components/common/fiveCardFlipGrid")
);
const Heading = dynamic(() => import("components/common/heading"));
const Slider = dynamic(() => import("components/common/slider"));
const Accordion = dynamic(() => import("components/common/accordion"));
const TabSlider = dynamic(() => import("components/common/tabSlider"));
const ResourceList = dynamic(() => import("components/common/resourceList"));
const BlogList = dynamic(() => import("components/common/blogList"));
const CardHorizontalList = dynamic(
  () => import("components/common/cardHorizontalList")
);
const BannerExchange = dynamic(
  () => import("components/common/bannerExchange")
);
const BannerEotc = dynamic(() => import("components/common/bannerEotc"));
const BannerInfoList = dynamic(
  () => import("components/common/bannerInfoList")
);
const BreadCrumb = dynamic(() => import("components/common/breadCrumb"));
const Spacer = dynamic(() => import("components/common/spacer"));
const VoideOtc = dynamic(() => import("components/common/voiceOtc"));
const BannerCustody = dynamic(() => import("components/common/bannerCustody"));
const CardHorizontalItems = dynamic(
  () => import("components/common/cardHorizontalItems")
);
const SixCardFlipGrid = dynamic(
  () => import("components/common/sixCardFlipGrid")
);
const BannerInstitutional = dynamic(
  () => import("components/common/bannerInstitutional")
);
const BannerInstitutionalHorizontal = dynamic(
  () => import("components/common/bannerInstitutionalHorizontal")
);
const InstitutionalMetrics = dynamic(
  () => import("components/common/institutionalMetrics")
);
const InstitutionalProducts = dynamic(
  () => import("components/common/institutionalProducts")
);
const InstitutionalAffiliates = dynamic(
  () => import("components/common/institutionalAffiliates")
);
const InstitutionalWhyUs = dynamic(
  () => import("components/common/institutionalWhyUs")
);
const DynamicCardGrid = dynamic(
  () => import("components/common/dynamicCardGrid")
);
const InstitutionalSegmentHero = dynamic(
  () => import("components/common/institutionalSegmentHero")
);
const InstitutionalCTA = dynamic(
  () => import("components/common/institutionalCTA")
);
const CardHorizontalGrid = dynamic(
  () => import("components/common/cardHorizontalGrid")
);
const StepCardHorizontal = dynamic(
  () => import("components/common/stepCardHorizontal")
);
const BaseComponent = dynamic(() => import("components/common/baseComponent"));
const CommonCTA = dynamic(() => import("components/common/commonCTA"));
const CommonHero = dynamic(() => import("components/common/commonHero"));
const InstitutionsMetrics = dynamic(
  () => import("components/common/institutionsMetrics")
);
const InstitutionsCardGrid = dynamic(
  () => import("components/common/institutionsCardGrid")
);
const InstitutionsHomepageHero = dynamic(
  () => import("components/common/institutionsHomepageHero")
);
const InstitutionsAffiliates = dynamic(
  () => import("components/common/institutionsAffiliates")
);
const InstitutionsProducts = dynamic(
  () => import("components/common/institutionsProducts")
);
const InstitutionsFAQ = dynamic(
  () => import("components/common/institutionsFAQ")
);
const InstitutionsWhyUs = dynamic(
  () => import("components/common/institutionsWhyUs")
);
const InstitutionsGiantCard = dynamic(
  () => import("components/common/institutionsGiantCard")
);
const InstitutionsBlog = dynamic(
  () => import("components/common/institutionsBlog")
);
const BannerVariant1 = dynamic(
  () => import("components/common/bannerVariant1")
);
const ContentfulResponsiveText = dynamic(
  () => import("components/common/contentfulResponsiveText")
);
const BannerAtm = dynamic(() => import("components/common/bannerAtm"));
const CardV2 = dynamic(() => import("components/common/cardV2"));
const TwoCardGrid = dynamic(() => import("components/common/twoCardGrid"));
const LargeCard = dynamic(() => import("components/common/largeCard"));
const ThreeCardGrid = dynamic(() => import("components/common/threeCardGrid"));
const HeadingV2 = dynamic(() => import("components/common/headingV2"));
const BannerInfoListV2 = dynamic(
  () => import("components/common/bannerInfoListV2")
);
const AccordionV2 = dynamic(() => import("components/common/accordionV2"));
const BannerPromo = dynamic(() => import("components/common/bannerPromo"));

export const componentNames = [
  {
    render: Card,
    value: "CARD"
  },
  {
    render: Banner,
    value: "BANNER"
  },
  {
    render: BadgesUk,
    value: "BADGES-UK"
  },
  {
    render: CardHorizontal,
    value: "CARD-HORIZONTAL"
  },
  {
    render: CardHorizontalInfo,
    value: "CARD-HORIZONTAL-INFO"
  },
  {
    render: CardFlipSlider,
    value: "CARD-FLIP-SLIDER"
  },
  {
    render: FiveCardFlipGrid,
    value: "FIVE-CARD-FLIP-GRID"
  },
  {
    render: Heading,
    value: "HEADING"
  },
  {
    render: Slider,
    value: "SLIDER"
  },
  {
    render: Accordion,
    value: "ACCORDION"
  },
  {
    render: TabSlider,
    value: "TAB-SLIDER"
  },
  {
    render: ResourceList,
    value: "RESOURCE-LIST"
  },
  {
    render: BlogList,
    value: "BLOG-LIST"
  },
  {
    render: CardHorizontalList,
    value: "CARD-HORIZONTAL-LIST"
  },
  {
    render: BannerExchange,
    value: "BANNER-EXCHANGE"
  },
  {
    render: BannerInfoList,
    value: "BANNER-INFO-LIST"
  },
  {
    render: BreadCrumb,
    value: "BREADCRUMB"
  },
  {
    render: Spacer,
    value: "SPACER"
  },
  {
    render: BannerEotc,
    value: "BANNER-EOTC"
  },
  {
    render: VoideOtc,
    value: "VOICE-OTC"
  },
  {
    render: BannerCustody,
    value: "BANNER-CUSTODY"
  },
  {
    render: CardHorizontalItems,
    value: "CARD-HORIZONTAL-ITEMS"
  },
  {
    render: SixCardFlipGrid,
    value: "SIX-CARD-FLIP-GRID"
  },
  {
    render: BannerInstitutional,
    value: "BANNER-INSTITUTIONAL"
  },
  {
    render: BannerInstitutionalHorizontal,
    value: "BANNER-INSTITUTIONS"
  },
  {
    render: InstitutionalMetrics,
    value: "INSTITUTIONAL-METRICS"
  },
  {
    render: DynamicCardGrid,
    value: "DYNAMIC-CARD-GRID"
  },
  {
    render: InstitutionalProducts,
    value: "INSTITUTIONAL-PRODUCTS"
  },
  {
    render: InstitutionalAffiliates,
    value: "INSTITUTIONAL-AFFILIATES"
  },
  {
    render: InstitutionalSegmentHero,
    value: "INSTITUTIONAL-SEGMENT-HERO"
  },
  {
    render: InstitutionalWhyUs,
    value: "INSTITUTIONAL-WHY-US"
  },
  {
    render: InstitutionalCTA,
    value: "INSTITUTIONAL-CTA"
  },
  {
    render: CardHorizontalGrid,
    value: "CARD-HORIZONTAL-GRID"
  },
  {
    render: StepCardHorizontal,
    value: "STEP-CARD-HORIZONTAL"
  },
  {
    render: BannerAtm,
    value: "GEMINI-MOBILE-BANNER"
  },
  {
    render: BaseComponent,
    value: "BASE-COMPONENT"
  },
  {
    render: CommonCTA,
    value: "COMMON-CTA"
  },
  {
    render: CommonHero,
    value: "COMMON-HERO"
  },
  {
    render: InstitutionsCardGrid,
    value: "INSTITUTIONS-CARD-GRID"
  },
  {
    render: InstitutionsMetrics,
    value: "INSTITUTIONS-METRICS"
  },
  {
    render: InstitutionsHomepageHero,
    value: "INSTITUTIONS-HOMEPAGE-HERO"
  },
  {
    render: InstitutionsAffiliates,
    value: "INSTITUTIONS-AFFILIATES"
  },
  {
    render: InstitutionsProducts,
    value: "INSTITUTIONS-PRODUCTS"
  },
  {
    render: InstitutionsFAQ,
    value: "INSTITUTIONS-FAQ"
  },
  {
    render: InstitutionsWhyUs,
    value: "INSTITUTIONS-WHY-US"
  },
  {
    render: InstitutionsGiantCard,
    value: "INSTITUTIONS-GIANT-CARD"
  },
  {
    render: InstitutionsBlog,
    value: "INSTITUTIONS-BLOG"
  },
  {
    render: BannerVariant1,
    value: "BANNER-VARIANT-1"
  },
  {
    render: ContentfulResponsiveText,
    value: "TEXT-COMPONENT"
  },
  { render: BannerAtm, value: "GEMINI-MOBILE-BANNER" },
  {
    render: CardV2,
    value: "CARD-V2"
  },
  {
    render: TwoCardGrid,
    value: "TWO-CARD-GRID"
  },
  {
    render: LargeCard,
    value: "LARGE-CARD"
  },
  {
    render: ThreeCardGrid,
    value: "THREE-CARD-GRID"
  },
  {
    render: HeadingV2,
    value: "HEADING-V2"
  },
  {
    render: BannerInfoListV2,
    value: "BANNER-INFO-LIST-V2"
  },
  {
    render: AccordionV2,
    value: "ACCORDION-V2"
  },
  {
    render: BannerPromo,
    value: "BANNER-PROMO"
  },
  {
    render: BannerNashvillePromo,
    value: "BANNER-NASHVILLE-PROMO"
  }
];

export function ContentfulComponent({
  data,
  slug,
  blogTypes
}: {
  data: any;
  slug: any;
  blogTypes: any;
}) {
  const { country } = useCountryStateCookies();

  // component types for overrides should all match
  const componentType = data?.fields?.componentType?.fields?.componentType;
  const restrictedList = data?.fields?.restrictedCountryList ?? [];
  const allowedList = data?.fields?.allowedCountryList ?? [];

  if (allowedList.length > 0 && !allowedList.includes(country)) {
    return null;
  }

  if (restrictedList.includes(country)) {
    return null;
  }

  const countryOverride = data?.fields?.countryOverride ?? [];
  const overridedData = countryOverride.filter(
    (override) => override?.fields?.country === country
  );

  // prioritizes override data if it exists
  const componentData = overridedData?.[0] ?? data;
  const Component =
    componentNames.find((data) => data?.value === componentType)?.render ||
    null;
  if (!Component) return null;
  return (
    <Component
      {...componentData}
      slug={slug}
      blogTypes={blogTypes}
      userCountry={country}
    />
  );
}
